import { axiosAuth } from "./auth";
import { z } from "zod";
import { EditProfileSchema } from "src/schemas/edit-profile";
import axios from "axios";
import { BASE_URL } from "src/lib/consts";

export const fetchCandidate = async () => {
  const response = await axiosAuth().get(
    `${BASE_URL}/getcandidate`,
  );
  return response.data.data.candidate;
};

export const updateProfilePictureService = async (file: File) => {
  const response = await axiosAuth().get(
    `${BASE_URL}/getupdateprofilepicurl?file=${file.name}`,
  );

  const { url, Key } = response.data.data;

  await axios.put(url, file);

  return Key;
};

export const uploadSignature = async (file: File) => {
  const response = await axiosAuth().get(
    `${BASE_URL}/get-sign-url?file=${file.name}`,
  );

  const { url, key } = response.data.data;

  await axios.put(url, file);

  return key;
};

export const editProfile = async (
  values: z.infer<typeof EditProfileSchema>,
) => {
  const payload = {
    adharNumber: values.aadharNumber,
    address: values.address,
    callingMobileNo: values.phoneNumber,
  };

  if (values.profilePicture) {
    await updateProfilePictureService(values.profilePicture);
  }

  await axiosAuth().patch(`${BASE_URL}/editprofile`, payload);

  return { success: "Details updated" };
};
